export default __webpack_public_path__ + "static/media/send-message.90edaad1.svg";